import { Component } from '@angular/core';

@Component({
  selector: 'icon-expand',
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-move-diagonal-icon lucide-move-diagonal">
        <path d="M11 19H5v-6"/>
        <path d="M13 5h6v6"/>
        <path d="M19 5 5 19"/>
    </svg>
  `,
  styles: [
   `
    svg {
        path {
          fill: var(--main-color);
        }
      }

      svg:hover {
        path {
          fill: var(--main-color-strong);
        }
      }
    `
  ]
})

export class ExpandIconComponent {

}
